module.exports = __webpack_public_path__ + "img/06.8b7a5553.png";